<div class="under-construction">
  <div class="content">
    <h1 class="mb-2">{{ 'UNDER-CONSTRUCTION.sorry' | translate }}</h1>
    <p class="mb-2">{{ 'UNDER-CONSTRUCTION.workingHard' | translate }}</p>
    <p class="mb-2">{{ 'UNDER-CONSTRUCTION.tryAgain' | translate }}</p>
    <img src="assets/img/maintenance.svg" alt="Maintenance" />
  </div>
</div>
